import * as React from 'react';
import * as URI from 'urijs';
import { translate } from 'components/translate-hoc';

import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

import { COPY_KEY_BUTTON_ANALYTICS, SHARE_LINK_QUERY_PARAM, TEXT_KEYS } from './share-link.constants';
import { IShareLinkProps } from './share-link.types';

import './share-link.styles.less';

export class ShareLink extends React.Component<IShareLinkProps> {
    public renderShareLinkInput(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;
        const ref: React.RefObject<HTMLDivElement> = React.createRef();
        /* This should be calculated only once, so inline callback is OK */
        const callback = (): void => {
            /* According to https://caniuse.com/ `window.getSelection` should work for all required browsers.
            * In case if not supported there will be exception, which is ok,
            * because shouldn`t break runtime. */
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(ref.current!);
            if (selection) {
                selection.removeAllRanges();
                selection.addRange(range);
                document.execCommand('copy');
            }
            AnalyticsService.sendClickEvent(COPY_KEY_BUTTON_ANALYTICS);
        };

        const currentURL = new URI(window.location.href);
        const validSegments = currentURL.segment().filter(segment => segment !== this.props.activeLanguageCode);
        const fullLink = new URI(currentURL.origin()).segment(validSegments).addQuery({
            [SHARE_LINK_QUERY_PARAM]: this.props.invitationId
        }).href();
        const buttonText = translateKey(TEXT_KEYS.COPY_BUTTON);

        return (
            <div className="sitegen-fr-share-link__wrapper">
                <div ref={ref} className="sitegen-fr-share-link__block-with-link">{fullLink}</div>
                <div className="sitegen-fr-share-link__copy-button" onClick={callback}>
                    {buttonText}
                </div>
            </div>
        );
    }

    public render() {
        const { dangerouslyTranslateWithHTML: translateKey, originalTranslateKey } = this.props;
        const gameName: string = originalTranslateKey(TEXT_KEYS.GAME_NAME);
        const titleText = translateKey(TEXT_KEYS.TITLE);
        const descriptionText = translateKey(TEXT_KEYS.DESCRIPTION, { gameName });
        const warningText = translateKey(TEXT_KEYS.WARNING);

        return (
            <div className="sitegen-fr-share-link">
                <div className="sitegen-fr-share-link__title">
                    {titleText}
                </div>
                <div className="sitegen-fr-share-link__description">
                    {descriptionText}
                </div>
                {this.renderShareLinkInput()}
                <div className="sitegen-fr-share-link__warning">
                    <span className="sitegen-fr-share-link__warning-icon">
                    </span>
                    {warningText}
                </div>
            </div>
        );
    }
}

export default translate()(ShareLink);
